module.exports = __webpack_public_path__ + "static/00008.c02273fc.jpg";